import { InputWithOptionsUniDriver } from '../InputWithOptions/InputWithOptions.uni.driver';

export interface DropdownUniDriver extends InputWithOptionsUniDriver {}
